import {removeServiceNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function removeServiceNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.removeServiceNote,
    mutationFn: (noteId: number) => removeServiceNote(id, noteId),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
